import './StoreFilterModal.less';

export const prefix = 'bm-c-store-filter-modal';

export { default } from './StoreFilterModal';
